import GaodeDistrictArea from './gaode_district_area.vue';

export default GaodeDistrictArea;
